var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#00a0df;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.73,
    y: 0.88,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.73,
    y: 0.88,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "add_pet",
    "data-name": "add pet"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.56,
    cy: 300.43,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M441.87,242.5H351.6V157.33a56.19,56.19,0,0,0-56-56h0a56.19,56.19,0,0,0-56,56V242.5H159.38a56.19,56.19,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56h80.17v85.27a56.19,56.19,0,0,0,56,56h0a56.19,56.19,0,0,0,56-56V354.55h90.27a56.19,56.19,0,0,0,56-56h0A56.19,56.19,0,0,0,441.87,242.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPet);
export default __webpack_public_path__ + "static/media/add_pet.4e729facb26d839fa6169b1ecebdf52f.svg";
export { ForwardRef as ReactComponent };